import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/core/state/state.service';
import { selectCurrentUser } from '@app/core/auth/auth.selectors';
import { combineLatest } from 'rxjs';
import { selectCurrentProject } from '@app/core/state/entities/project/project.selectors';
import { selectCurrentStage } from '@app/core/state/entities/stage/stage.selectors';
import * as Sentry from '@sentry/angular';
import { AppConfigService } from '../config/app-config.service';
import { getCurrentStudy } from '@core/state/entities/study/study.selectors';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor(
    private _store: Store,
    private _configService: AppConfigService
  ) {}

  init() {
    this.observe();
  }

  private observe() {
    combineLatest([
      this._store.select(selectCurrentProject),
      this._store.select(selectCurrentStage),
      this._store.select(getCurrentStudy),
      this._store.select(selectCurrentUser),
    ]).subscribe(([project, stage, study, user]) => {
      const scope = Sentry.getCurrentScope();
      scope.setUser({
        ...user,
      });
      scope.setTags({
        ...(project && { 'project-id': project.id }),
        ...(project && { 'project-name': project.name }),
        ...(stage && { 'stage-id': stage.id }),
        ...(stage && { 'stage-name': stage.name }),
        ...(study && { 'study-id': study.id }),
        ...(study && { 'study-title': study.title }),
      });
    });
  }
}
